<template>
  <form class="form-horizontal">
    <wizard-form-row>
      <template v-slot:label>When were you born?</template>
      <select class="form-control input-sm" :value="formData.bornDateMonth"
        @change="setFormData({ bornDateMonth: $event.target.value })"
        :disabled="bornDateMonths.length === 0">
        <option value="">- select -</option>
        <option v-for="month in bornDateMonths" :value="month.value" :key="month.value">{{ month.name }}</option>
      </select>
      <select class="form-control input-sm" :value="formData.bornDateYear"
        @change="setFormData({ bornDateYear: $event.target.value })">
        <option value="">- select -</option>
        <option v-for="year in bornDateYears" :value="year" :key="year">{{ year }}</option>
      </select>
    </wizard-form-row>
    <wizard-form-row>
      <template v-slot:label>
        What is your
        <span class="text-underline" v-popover.hover="tooltips.payEntryBaseDate">
          Pay Entry Base Date
        </span>
        ?
      </template>
      <select class="form-control input-sm" :value="formData.payEntryBaseDateMonth"
        @change="setFormData({ payEntryBaseDateMonth: $event.target.value })"
        :disabled="payEntryBaseDateMonths.length === 0">
        <option value="">- select -</option>
        <option v-for="month in payEntryBaseDateMonths" :value="month.value" :key="month.value">{{ month.name }}</option>
      </select>
      <select class="form-control input-sm" :value="formData.payEntryBaseDateYear"
        @change="setFormData({ payEntryBaseDateYear: $event.target.value })"
        :disabled="payEntryBaseDateYears.length === 0">
        <option value="">- select -</option>
        <option v-for="year in payEntryBaseDateYears" :value="year" :key="year">{{ year }}</option>
      </select>
    </wizard-form-row>
    <wizard-form-row>
      <template v-slot:label>What is your current grade?</template>
      <select class="form-control input-sm" :value="formData.grade"
        @change="setFormData({ grade: $event.target.value })">
        <option value="">- select -</option>
        <option v-for="grade in gradeOptions" :value="grade" :key="grade">{{ grade }}</option>
      </select>
    </wizard-form-row>
    <wizard-form-row v-if="showFor('ac2ac', 'ac2rc')">
      <template v-slot:label>
        What is your
        <span class="text-underline" v-popover.hover="tooltips.activeServiceDate">
          Active Service Date
        </span>
        ?
      </template>
      <div class="checkbox">
        <label>
          <input type="checkbox" :checked="sameAsPayDate" @change="setSameAsPayDate($event.target.checked)" /> same as Pay Entry Base Date
        </label>
      </div>
      <div v-show="!sameAsPayDate">
        <select class="form-control input-sm" :value="formData.activeServiceDateMonth"
          @change="setFormData({ activeServiceDateMonth: $event.target.value })"
          :disabled="activeServiceDateMonths.length === 0">
          <option value="">- select -</option>
          <option v-for="month in activeServiceDateMonths"
            :value="month.value" :key="month.value">{{ month.name }}</option>
        </select>
        <select class="form-control input-sm" :value="formData.activeServiceDateYear"
          @change="setFormData({ activeServiceDateYear: $event.target.value })"
          :disabled="activeServiceDateYears.length === 0">
          <option value="">- select -</option>
          <option v-for="year in activeServiceDateYears" :value="year" :key="year">{{ year }}</option>
        </select>
      </div>
    </wizard-form-row>
    <wizard-form-row>
      <template v-slot:label>How many years of service will you have at separation or retirement?</template>
      <select class="form-control input-sm" :value="formData.retirementSTYears"
        @change="setFormData({ retirementSTYears: $event.target.value })"
        :disabled="retirementSTYears.length === 0">
        <option value="">- select -</option>
        <option v-for="value in retirementSTYears" :value="value" :key="value">{{ value }}</option>
      </select>
      year(s)
      <select class="form-control input-sm" :value="formData.retirementSTMonths"
        @change="setFormData({ retirementSTMonths: $event.target.value })"
        :disabled="retirementSTMonths.length === 0">
        <option value="">- select -</option>
        <option v-for="value in retirementSTMonths" :value="value" :key="value">{{ value }}</option>
      </select>
      month(s)
    </wizard-form-row>
    <wizard-form-row v-if="showFor('ac2rc')">
      <template v-slot:label>When do you plan to join the Reserve component?</template>
      <select class="form-control input-sm" :value="formData.transferToRcYears"
        @change="setFormData({ transferToRcYears: $event.target.value })"
        :disabled="typeof transferToRcYears === 'undefined' || transferToRcYears.length === 0">
        <option value="">- select -</option>
        <option v-for="value in transferToRcYears" :value="value" :key="value">{{ value }}</option>
      </select>
      year(s)
      <select class="form-control input-sm" :value="formData.transferToRcMonths"
        @change="setFormData({ transferToRcMonths: $event.target.value })"
        :disabled="typeof transferToRcMonths === 'undefined' || transferToRcMonths.length === 0">
        <option value="">- select -</option>
        <option v-for="value in transferToRcMonths" :value="value" :key="value">{{ value }}</option>
      </select>
      month(s)
    </wizard-form-row>
    <wizard-form-row v-if="showFor('rc2ac')">
      <template v-slot:label>When do you plan to join the Active component?</template>
      <select class="form-control input-sm" :value="formData.transferToAcYears"
        @change="setFormData({ transferToAcYears: $event.target.value })"
        :disabled="typeof transferToAcYears === 'undefined' || transferToAcYears.length === 0">
        <option value="">- select -</option>
        <option v-for="value in transferToAcYears" :value="value" :key="value">{{ value }}</option>
      </select>
      year(s)
      <select class="form-control input-sm" :value="formData.transferToAcMonths"
        @change="setFormData({ transferToAcMonths: $event.target.value })"
        :disabled="typeof transferToAcMonths === 'undefined' || transferToAcMonths.length === 0">
        <option value="">- select -</option>
        <option v-for="value in transferToAcMonths" :value="value" :key="value">{{ value }}</option>
      </select>
      month(s)
    </wizard-form-row>
    <wizard-form-row v-if="showFor('rc2ac', 'rc2rc')" :hasError="activeServiceDaysHasError">
      <template v-slot:label>
        What is your total number of
        <span class="text-underline" v-popover.hover="tooltips.activeService">Active Service</span>
        days to date?
      </template>
      <input type="number" class="form-control input-sm"
        :min="config.activeServiceDaysMin" :max="config.activeServiceDaysMax"
        :value="formData.activeServiceDays"
        @input="setFormData({ activeServiceDays: Number(Number($event.target.value).toFixed(0)) })" />
    </wizard-form-row>
    <wizard-form-row v-if="showFor('rc2ac', 'rc2rc')">
      <template v-slot:label>
        How many
        <span class="text-underline" v-popover.hover="tooltips.qualifyingYears">Qualifying Years</span>
        towards retirement have you earned?
      </template>
      <select class="form-control input-sm" :value="formData.qualifyingYears"
        @change="setFormData({ qualifyingYears: $event.target.value })"
        :disabled="qualifyingYearsOptions.length === 0">
        <option v-for="value in qualifyingYearsOptions" :key="value" :value="value">{{ value }}</option>
      </select>
    </wizard-form-row>
    <wizard-form-row v-if="showFor('rc2ac', 'rc2rc')" :hasError="retirementPointsHasError">
      <template v-slot:label>How many retirement points in total do you have to date?</template>
      <input type="number" class="form-control input-sm"
        :min="config.retirementPointsMin" :max="config.retirementPointsMax"
        :value="formData.retirementPoints"
        @input="setFormData({ retirementPoints: Number(Number($event.target.value).toFixed(0)) })" />
    </wizard-form-row>
  </form>
</template>

<script>
import personalInformationFormMixin from '@/js/mixins/calculator/personal-information-form-mixin';

export default {
  mixins: [personalInformationFormMixin],
};
</script>
